import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import {
  ClientPaymentsSection,
  PaymentHistorySection,
  PendingPaymentsSection,
} from "~/pages/clients/components/client-detail/payment-sections";
import OrderDetailDialog from "~/pages/purchase-orders/OrderDetailDialog";
import { usePayments } from "~/pages/purchase-orders/hooks/usePayments";
import { SalesRequest } from "~/types/client";
import { PurchaseOrder } from "~/types/user";

interface PaymentsTabProps {
  clientOrders: PurchaseOrder[];
}

const PaymentsTab: React.FC<PaymentsTabProps> = ({ clientOrders }) => {
  const { clientId } = useParams<{ clientId: string }>();
  const { payments, loading } = usePayments(clientId || null);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);

  // Function to convert PurchaseOrder to SalesRequest format
  const convertToSalesRequest = (order: PurchaseOrder): SalesRequest => {
    return {
      id: order.id,
      clientId: order.clientId,
      createdBy: order.sellerId || "",
      approvedRejectedBy: undefined,
      status:
        order.status === "approved"
          ? "accepted"
          : order.status === "rejected"
            ? "rejected"
            : "pending",
      paid: order.paymentStatus === "cleared",
      paymentTerms: 30, // Default value since PurchaseOrder doesn't have this
      paymentType: "future", // Default value
      paymentDueDate: new Date().toISOString(), // Default value
      totalAmount: order.total,
      comments: "",
      deliveryDate: order.createdAt,
      deliveryAddressId: undefined,
      deliveryStreet: order.deliveryAddress || "",
      createdAt: order.createdAt,
      updatedAt: order.createdAt,
      rejectedReason: order.rejectionReason,
    };
  };

  const handleViewOrderClick = (salesRequestId: string) => {
    setSelectedOrderId(salesRequestId);
  };

  const selectedOrder = clientOrders.find(
    (order) => order.id === selectedOrderId
  );

  return (
    <div className="space-y-6 p-4 pt-6 md:p-6">
      <ClientPaymentsSection
        payments={payments}
        loading={loading}
        onViewOrder={handleViewOrderClick}
      />

      <PendingPaymentsSection
        orders={clientOrders.filter(
          (order) =>
            order.status === "approved" &&
            (order.paymentStatus === "pending" ||
              order.paymentStatus === "late")
        )}
        onViewOrder={handleViewOrderClick}
      />

      <PaymentHistorySection
        orders={clientOrders.filter(
          (order) =>
            order.status === "approved" && order.paymentStatus === "cleared"
        )}
        onViewOrder={handleViewOrderClick}
      />

      {selectedOrderId && selectedOrder && (
        <OrderDetailDialog
          selectedOrder={convertToSalesRequest(selectedOrder)}
          setSelectedOrder={() => setSelectedOrderId(null)}
          getSellerInfo={() => ({ name: "", lastname: "", email: "" })}
          getApproverRejecterInfo={() => ({
            name: "Sistema",
            lastname: "",
            email: "",
            role: "system",
          })}
          clientNames={{ [selectedOrder.clientId]: selectedOrder.clientName }}
          items={(selectedOrder.items || []).map((item) => ({
            id: item.productId,
            salesRequestId: selectedOrder.id,
            productId: item.productId,
            quantity: item.quantity,
            unitPrice: item.pricePerUnit,
          }))}
          onOrderStatusChange={() => {}}
        />
      )}
    </div>
  );
};

export default PaymentsTab;
